import { render } from "./ImportProductoFrecuente.vue?vue&type=template&id=a7621a94"
import script from "./ImportProductoFrecuente.vue?vue&type=script&lang=js"
export * from "./ImportProductoFrecuente.vue?vue&type=script&lang=js"

import "./ImportProductoFrecuente.vue?vue&type=style&index=0&id=a7621a94&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__